import {Injectable} from '@angular/core';
import {HttpClient, HttpContext} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';
import {WefitPartnerService} from '../wefit/wefit-partner.service';
import {SKIP_ERROR_ALERT} from '../../interceptors/http.interceptor';

// La card dashboard du test apparaît durant les N derniers jours avant l'expiration du TP Wefit
export const ASSESSMENT_WINDOW_DAYS = 30;

// group_id des utilisateurs B2C : le test de fin de formation ne les concerne pas
export const B2C_GROUP_IDS: number[] = [31, 247, 250, 1134, 1151];

@Injectable({
  providedIn: 'root'
})
export class AssessmentService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService,
    private wefitPartnerSrv: WefitPartnerService
  ) {
  }

  // Date de fin de formation (TP Wefit le plus récent pour la langue), null si aucun
  async getTrainingEndDate(langCode: string): Promise<Date | null> {
    const tps = await this.wefitPartnerSrv.getTrainingPrograms();
    const code = langCode.toLowerCase();
    const tp = (tps ?? [])
      .filter(t => t.formation_code?.toLowerCase() === code && t.date_end && t.method === 'eLearning')
      .sort((a, b) => new Date(b.date_end).getTime() - new Date(a.date_end).getTime())[0];
    return tp ? new Date(tp.date_end) : null;
  }

  // 404 attendu tant que le test n'existe pas pour la langue : null, sans toast d'erreur
  async state() {
    try {
      return await this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}assessment/state`, {
        context: new HttpContext().set(SKIP_ERROR_ALERT, true)
      }).toPromise();
    } catch (e) {
      return null;
    }
  }

  start() {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint()}assessment/start`, {}).toPromise();
  }

  answer(values: any) {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint()}assessment/answer`, values).toPromise();
  }

  result() {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}assessment/result`).toPromise();
  }

  isB2C(user: any): boolean {
    const groupId = user?.group?.id ?? user?.group_id ?? user?.groupId ?? null;
    return groupId !== null && B2C_GROUP_IDS.includes(Number(groupId));
  }

}
